import { render } from "./ProjTag.vue?vue&type=template&id=37149d3e"
import script from "./ProjTag.vue?vue&type=script&lang=js"
export * from "./ProjTag.vue?vue&type=script&lang=js"

import "./ProjTag.vue?vue&type=style&index=0&id=37149d3e&lang=css"

import exportComponent from "/Users/yenneelim/Development/signon_static/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__